<template>
  <div v-bind:class="{ 'input-string': true, 'with-unit': unit !== '' }">
    <input type="text" v-model="stringValue" /> <span v-show="unit !== ''">{{ unit }}</span>
  </div>
</template>

<script>
export default {
  name: 'input-string',
  props: [ 'settingKey', 'unit' ],
  computed: {
    stringValue: {
      get () {
        let configuration = this.$store.state.settingsPage.configuration
        if (this.settingKey in configuration) {
          return configuration[this.settingKey].value
        }
        return ''
      },
      set (value) {
        let item = {
          key: this.settingKey,
          value: value
        }
        this.$store.commit('settingsPage/setConfigurationItem', item)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.input-string > * {
  display: inline-block;
  vertical-align: middle;
  margin-top: 5px;
}
input[type="text"] {
  font-size: 14px;
  padding: 7px 10px;
}

.input-string.with-unit {
  & input[type="text"] {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    width: 250px;
  }

  & span {
    font-size: 12px;
    background-color: #555;
    color: #fff;
    padding: 9px 10px 10px;
    margin-left: -5px;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
  }
}

@media only screen and (max-width: 430px) {
  .input-string.with-unit {
    input[type="text"] {
      width: 100%;
    }
    span {
      width: fit-content;
      margin-left: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Settings/controls/InputString.vue